import React from 'react';

import Checkbox from '@amzn/meridian/checkbox';
import Input from '@amzn/meridian/input';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import type { RegionFormTableRow } from 'src/store/adminConfigPageSlice/regionTasksPageSlice/types';

import { ROW_HEIGHT } from './constants';

// **** Constants **** //

const INPUT_FIELD_LAYOUT = ['grid-2', 'grid-2'];

// **** Types **** //

interface FormTaskBodyProps {
  region: RegionFormTableRow;
  onUpdate: (region: RegionFormTableRow) => void;
}

// **** Components **** //

/**
 * Default component
 */
const FormTaskBody = ({ region, onUpdate }: FormTaskBodyProps) => (
  <>
    <Row widths={INPUT_FIELD_LAYOUT} height={ROW_HEIGHT}>
      <Text>Restriction Form Name</Text>
      <Input
        type="text"
        placeholder="Enter form name..."
        value={region.formName}
        aria-label="Restriction Form Name"
        onChange={(formName) => onUpdate({ ...region, formName })}
      />
    </Row>

    <Row widths={INPUT_FIELD_LAYOUT} height={ROW_HEIGHT}>
      <Text>Country</Text>
      <Text>{region.country}</Text>
    </Row>

    <Row widths={INPUT_FIELD_LAYOUT} height={ROW_HEIGHT}>
      <Text>Region/State/Province</Text>
      <Text>{region.name}</Text>
    </Row>

    <Row widths={INPUT_FIELD_LAYOUT} height={ROW_HEIGHT}>
      <Text>Description</Text>
      <Input
        type="text"
        placeholder="Enter description..."
        aria-label="Description"
        value={region.description}
        onChange={(description) => onUpdate({ ...region, description })}
      />
    </Row>

    <Row widths={INPUT_FIELD_LAYOUT} height={ROW_HEIGHT}>
      <Text>Is Active?</Text>
      <Checkbox
        checked={region.isActive}
        aria-label="Is Active?"
        onChange={(isActive) => onUpdate({ ...region, isActive })}
      />
    </Row>
  </>
);

// **** Export **** //

export default FormTaskBody;
